import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { QUOTA_MODE } from 'data/quotaModes';
import { ActionVisibilityValueType } from 'utils/adl-services';
import {
  makeSelectNodesWithLogicFromOutcomesShow,
  makeSelectAnswersWithLogicFromOutcomes,
  selectQuestionnaireQuestions,
} from 'containers/QuestionnairePage/selectors';

import { getNodeByRefIdDeep } from 'containers/QuestionnairePage/utils';
import {
  canShowHideAnswers,
  enrichAnswersWithVisibility,
  getAnswersVisibilityList,
} from '../utils';

function useStatePropsAndActions({
  refId,
  nodeRefId,
  valueType,
  quotaMode = QUOTA_MODE.NONE,
}) {
  const nodes = useSelector(selectQuestionnaireQuestions);
  const nodesWithDisplayLogic = useSelector(
    makeSelectNodesWithLogicFromOutcomesShow,
  );
  const answersWithLogicFromOutcomes = useSelector(
    makeSelectAnswersWithLogicFromOutcomes,
  );
  const { isEnabled, isSet, cannotSet } = useMemo(() => {
    if (valueType === ActionVisibilityValueType.Node) {
      return {
        isEnabled: true,
        isSet: nodesWithDisplayLogic.includes(nodeRefId),
        cannotSet: false,
      };
    }

    const node = getNodeByRefIdDeep(nodes, nodeRefId);

    if (!node) {
      return { isEnabled: false };
    }

    const list = enrichAnswersWithVisibility({
      nodeType: node.type,
      isScreening: node.isScreening,
      answers: getAnswersVisibilityList(node, valueType),
      answersWithLogicFromOutcomes,
    });

    const item = list.find(
      (listItem) => listItem.refId === refId || listItem.answerRefId === refId,
    );

    return {
      isEnabled: canShowHideAnswers(node),
      isSet: item?.isVisibleByLogicSet || false,
      cannotSet:
        quotaMode !== QUOTA_MODE.NONE ||
        item?.isVisibleByLogicCannotSet ||
        false,
    };
  }, [
    nodes,
    nodeRefId,
    refId,
    nodesWithDisplayLogic,
    answersWithLogicFromOutcomes,
    valueType,
    quotaMode,
  ]);

  return {
    isEnabled,
    isSet,
    cannotSet,
  };
}

export default useStatePropsAndActions;
